/**
 * Created by aimurat on 17.05.18.
 */
import {ICadaster} from "../../new-information/services/land.service";
import {INotificationTicket} from "../../new-information/services/notification.service";
import {BuildingStageStatus} from "../../new-construction/models/stages.models";

export interface IObject {
	finances: number;
	id: number;
	name?: string;
	region: IRegion;
	city: ICity;
	latitude?: number;
	longitude?: number;
	development_start_date: number;
	development_end_date: number;
	investments: IInvestments;
	developer: IDevelopers;
	spots: ISpot[];
	photo_id?: any;
	total_flat_area?: number;
	total_flat_count?: number;
	sales_flat_count?: number;
	remove_spot_ids?: number[];
	out_id?: string;
	zoom?: boolean;
	duration?: number;
	docs?: IContractGuarantee[];
	completion_percent?: number;
  completion_percent_old?: number;
  curators?: ICurator[];
	src?: string;
	flatRealization?: any[];
	docs3?: any[];
	livingComplexFactFlatArea?: number;
	buildingDocumentsCount?: number;
	portalID: number;
	ppInvCost_AuthorSuperv?: number;
	ppInvCost_ConstrWork?: number;
	ppInvCost_TechnicalSuperv?: number;
	privatePartnerID?: number;
	privatePartnerTitle?: string;
	bD_FlatArea?: number;
	bD_FlatCount?: number;
	bdInvCost_AuthorSuperv?: number;
	bdInvCost_ConstrWork?: number;
	bdInvCost_TechnicalSuperv?: number;
	delayEndDate?: number;
	estimateCost?: number;
	guarantObligationPercent?: number;
	pP_FlatArea?: number;
	landPlotTypeID?: number;
	pP_FlatCount?: number;
	leaseExpDate?: number;
	counter?: number;
	realizationPer?: number;
	investAmounts?: any[];
	own_investments2?: number;
	bd_investments2?: number;
	constProgressEnd?: boolean;
	bdInvCost_AddExp?: number;
	ppInvCost_AddExp?: number;
	timestamp?: any;
	cadastral: string;
  cadasters?: ICadaster[];

  development_start?: string;
  development_end?: string;
  commercial_title?: string;
  livingComplexFlatCount?: number;
  livingComplexFlatArea?: number;
  notificationTicket?: string;
  notificationTicketDate?: string;

  notificationTicketJSON?: INotificationTicket[];
  contractFileJSON?: IContractGuarantee[];
  commissioningDocumentFlag?: boolean;
  new_BP?: boolean;
  realizationPercent?: number;
  financePercent?: number;
  buildingPercent?: number;
  filledItemCount?: number;
  isWarrantyCase?: boolean;
  lastReportAcceptanceLevel?: string; //1 - На создании; 2 - На рассмотрении; 3 - Принят
  lastReportAcceptanceLevelID?: number;
  isBuildingStagesStatusUpd?: number | null;
}

export interface IContractGuarantee {
  certificateNumber?: string | number;
  dbFileID?: number;
  documentTypeID?: number;
  fileName?: string;
  contractDate: string;
  contractNumber: string;
  file?: File;
  addAgreementEndDate?: string; // дата смр для 12-го поле
  isAnotherDocumentTypeID?: boolean; // признак для documentTypeID 7
  buildingStagesStatusID?: BuildingStageStatus;
}


export interface ICurator {
  /** Поле модели куратора в объекте */
	departmentTitle?: string;
  /** Поле модели куратора в объекте */
	phoneNumber?: string;
  /** Поле модели куратора в объекте */
	fullName?: string;
  /** Поле модели куратора в объекте */
	userId?: number;

  /** Поле модели при получении кураторов */
  userID?: number;
  /** Поле модели при получении кураторов */
  name?: string;

  active?: boolean;
}


export interface IObject1 {
	development_start_date: number;
}
export interface IDevelopers {
	responsible: IDeveloper;
	general_contractor: IDeveloper;
	author_supervision: IDeveloper;
	technical_supervision: IDeveloper;
	supervisor: IDeveloper;
  authorized_organization: IDeveloper;
	private_partner?: IDeveloper;
}


export interface IDeveloper {
  // Для всех видов кроме супервайзера
  typeID?: number;
  title?: string;
  bin?: string;

  // Для супервайзера и куратора
  id?: number;
  name?: string;
  phone?: string;

  active?: boolean;
}

export enum SupervisorInfo {
  responsible = 'Ответственный',
  general_contractor = "Подрядчик",
  author_supervision = "Авторский надзор",
  technical_supervision = "Технический надзор",
  supervisor = "Супервайзер",
  curators = 'Куратор',
  authorized_organization = 'Уполномоченная компания',
  private_partner = 'Частный партнер'
}

export interface IInvestments {
	own_investments: number;
	own_investments2: number;
	bd_investments: number;
	bd_investments2: number;
	implementation_amount: number;
}

export interface IRegion {
	id: number;
	name: string;
	livingComplexCount?: number;
	active?: boolean;
}

export interface ICity {
	id: number;
	name: string;
	livingComplexCount?: number;
	active?: boolean;
}

export interface IUser {
	id: number;
	username: string;
	region: IRegion[];
	mio: any;
}

export interface ISpotWrapper {
	spots: ISpot;
	stages: IStage[];
}

export interface ISpot {
	id?: number; //
  number?: string | any; //
	floors?: number; //
	apartment_number?: number; //
	developer_id?: number; //
	developer_title?: string; //
	total_area?: number; //
	rank?: string; //
	rank_id?: number; //
	stages?: IStage[];
	completionPercent?: number;

	homeNumber?: string; //
	hasMansard?: boolean; //
	totalFlatAmount?: number; //
	totalFlatArea?: number; //
	realisationPercent?: number; //
	residueFlatCount?: number; //
	fullInfo?: boolean;
	isSimpleStagesInput?: boolean;

	isOpen?: boolean;
	mansardRooms?: RoomTypeItem;
	commercialRooms?: RoomTypeItem[];
	auxiliaryRooms?: RoomTypeItem[];
	parkingRooms?: RoomTypeItem[];
	wallMaterials?: WallMaterialType[];
	spotRanks?: SpotRank[]; //
	apartmentCount?: Floor[];
	countRoomsOfFloor?: number[][];
	apartmentScheme?: Flat[][];
	countRooms?: CountRooms[];
	flatRealization?: any[];
	flatConfiguration?: any[];
	docs?: ActDoc[];
	calendarActVis?: boolean;
	disCalendar?: boolean;
  color?: string;
  buildingNumber?: string;
}

export interface ActDoc {
	buildingID?: number;
	dbFileID?: number;
	documentTypeID?: number;
	fileExtension?: string;
	fileName?: string;
	updatedOn?: string;
	documentDate?: string;
}
export interface SetBuilding {
	LivingComplexID: number;
	BuildingID?: number;
	BuildingNumber: string;
	FloorCount: number;
	FlatCount: number;
	FlatArea?: number;
	BuildingClassID?: number;
	DeveloperID?: number;
	HomeNumber: string;
	HasMansard: boolean;
}

export interface WallMaterialType {
	id: number;
	title: string;
	wall_material: WallMaterial[];
	active: boolean;
}
export interface WallMaterial {
	id: number;
	title: string;
	checked?: boolean;
}
export interface RoomType {
	id: number;
	title: string;
	type: RoomTypeItem[];
	modal?: boolean;
}
export interface RoomTypeItem {
	id: number;
	title: string;
	area: number;
	checked?: boolean;
	placeCount: number;
	roomTypeID?: number;
	photoFileID?: number;
	subItems?: SubItem[];
}

export interface SubItem {
	id: number;
	title: string;
	checked?: boolean;
}


export interface OneRoomTypeInfo {
	area: number;
	placeCount: number;
	roomTypeID: number;
	roomTypeItemID: number;
	photoFileID?: number;
}
export interface SpotRank {
	id: number;
	title: string;
	checked?: boolean;
}
export interface CountRooms {
	roomCountID: number;
	roomCountTitle: string;
	flatCount: number;
}
export interface Flat {
	columnID: number;
	flatConfigurationID: number;
	flatID: number;
	roomCountID: number;
	isCornerFlat?: boolean;
	flatRoom: number;
	flatNumber: string;
	saleDate: string;
}
//Model for get method for Building Flats Info
export interface BuildingFlat {
	set1: Floor[];
	set2: FloorScheme[];
	set3: CountRooms[];
	set4: FloorInfoSet4[] | any[];
}
export interface BuildingFlatSet4 {
  columnID: number;
  flatArea: number;
  flatConfigurationID: number;
  flatNumber: number;
  floorID: number;
  id: number;
  isCornerFlat: boolean;
  roomCountID: number;
  saleDate: string;
}
export interface Floor {
	floorID: number;
	floorTitle: string;
	flatCount: number;
	flatArea: number;
}
export interface Floor1 {
	floorID: number;
	floorTitle: string;
	flatCount: number;
	flatArea: number;
}
export interface FloorScheme {
	floorID: number;
	floorTitle: string;
	roomCountID: number;
	flatCount: number;
	flatConfigurationID: number;
	totalFlatArea: number;
	totalFlatAmount: number;
	rank: number;
	rank_id: number;
	stages?: IStage[];
}
export interface BuildingWallMaterials {
	buildingID: number;
	wallMaterialsList: number[];
}
export interface BuildingOtherRooms {
	// public int BuildingID { get; set; }
	//       public int RoomTypeItemID { get; set; }
	//       public bool? Delete { get; set; }
	//       public double? Area { get; set; }
	//       public int? PlaceCount { get; set; }
	BuildingID: number;
	RoomTypeItemID: number;
	Delete: boolean;
	Area: number;
	PlaceCount: number;
	PhotoFileID: number;
	File?: any;
}
export interface BuildingFloor {
	buildingID: number;
	floorID: number;
	roomCountID: number;
	flatCount: number;
}

export interface IStage {
	number: number;
	complete: number;
	start_date: number;
	end_date: number;
	isOpen?: boolean;
	completeOpen?: boolean;
}
// models for charts
export interface IPlanSales {
	flatCount: number;
	flatPlanAmount: number;
	salesFlatAmount: number;
	salesFlatCount: number;
	totalFlatArea: number;
}

export interface ISales {
	salesFlatAmount: number;
	salesFlatCount: number;
	salesMonth: number;
	salesYear: number;
}

export interface VerticalBarChart {
	reportDate: string;
	value: number;
}

export interface IFlatSalesWrapper {
	years: number[];
	flatSales: IFlatSales;
}

export interface IFlatSales {
	livingComplexId: number;
	total_apartments: number;
	realized_apartments: number;
	realization_plan_sum: number;
	realization_fact_sum: number;
	realized_apartments_by_date: any;
	realization_fact_by_date: any;
}

export interface IFlatsIn {
	numb: number;
	area: number;
	val: number;
	price: number;
	dateofreal: any;
	valof: number;
}

export interface Typeofotd {
	id: number;
	title: string;
	typeObject: TypeofotdTypes[];
	active?: boolean;
}
export interface TypeofotdTypes {
	furnishTypeID: number;
	id: number;
	title: string;
	checked?: boolean;
}

export interface View {
	furnishTypeID: number;
	id: number;
	title: string;
}
export interface FlatsInfo {
	roomCountID: number;
	roomCountTitle: string;
	totalFlatCount: number;
	totalFlatAmount: number;
	salesFlatCount: number;
	salesFlatAmount1: number;
	salesFlatAmount2: number;
	income: number;
	residueFlatCount: number;
	residueFlatAmount: number;
}
export interface Block {
	id: number;
	title?: string;
	blockNumber?: string;
	buildingID?: number;
}
export interface Blocks {
	livingComplexID: number;
	buildingID: number;
	id: number;
	title: string;
	blockNumber: string;
}


export enum citiesEnum {
  almaty = "г.Алматы",
  shymkent = "г.Шымкент",
  nursultan = "г.Нур-Султан"
}

export enum rolesEnum {
  BDAdmin = "BDAdmin",
  MioAdministrator = "MioAdministrator",
  MioRegionAdministrator = "MioRegionAdministrator",
  MioUser = "MioUser",
  MioReadOnlyUser = "MioReadOnlyUser",
  Techsupervision_hgf = "Techsupervision_hgf",
  PMD_HGF = "PMD_HGF",
  DashboardUser = "DashboardUser",
  WidgetAdmin = "WidgetAdmin"
}

/** Ответ Users/GetFIO (ServerService.getUserInfo) */
export interface IUserInfo {
  firstName: string;
  lastName: string;
  middleName: string;
  mio: { id: number; title: string }[];
  region: IRegion[];
  roles: string[];

  [key: string]: any;
}



export interface SingleNews {
  dbFileID: number;
  id: number;
  newsText: string;
  title: string;
  updatedOn: string;
  isOpen?: boolean;
  isChecked?: number;
}







export interface FlatsFloorInfo {
  set1: FloorInfoSet1[];
  set2: FloorInfoSet2[];
  set3: FloorInfoSet3[];
  set4: FloorInfoSet4[];
}
export interface FloorInfoSet1 {
  floorID: number;
  floorTitle: string;
  flatCount: number;
  flatArea: number;
}
export interface FloorInfoSet1Ex {
  flatCount?: number;
  floorID: number;
  floorTitle: string;
  flatArea: number;
  flatsArr?: InfoAboutFlatEx[];
}

export interface InfoAboutFlatEx {
  info: InfoAboutFlat[];
}

export interface InfoAboutFlat {
  columnID: number;
  flatArea: number;
  flatConfigurationID: number;
  flatID: number;
  flatNumber: string;
  isSale: boolean;
  roomCountID: number;
  isCornerFlat: boolean;
}

export interface FloorInfoSet2 {
  floorID: number;
  flatCount: number;
  floorTitle: string;
  flatConfigurationID: number;
  roomCountID: number;
}
export interface FloorInfoSet3 {
  flatCount: number;
  roomCountID: number;
  roomCountTitle: string;
}

export interface FloorInfoSet4 {
  id: number;
  columnID: number;
  flatConfigurationID: number;
  flatNumber: string;
  floorID: number;
  roomCountID: number;
  isCornerFlat: boolean;
  saleDate: string;
  flatArea: number;
}


export enum RoomTypeEnum {
  Flats = 0,
  Commercial = 1,
  Parking = 2
}
